<i18n>
{
  "en": {
    "edit": "Edit",
    "delete": "Delete",
    "visible": "Visible",
    "special": "Special",
    "outOfStock": "Out of stock",
    "specialFrame": "Special frame",
    "product": "Product",
    "deleted": "Deleted",
    "noNameError": "Nameless product",
    "errorProduct": "The product have an error"
  },
  "es": {
    "edit": "Editar",
    "delete": "Eliminar",
    "visible": "Visible",
    "special": "Especial",
    "outOfStock": "Sin stock",
    "specialFrame": "Marco especial",
    "product": "Producto",
    "deleted": "Borrado",
    "noNameError": "Producto sin nombre",
    "errorProduct":  "El producto tiene un error"
  }
}
</i18n>

<template>
  <dynameat-row :title="commercialName" :description="product.name" :button-config-list="buttonConfigList"
                :collapse-items="!$vuetify.breakpoint.mdAndUp" @click-content="onClickContent"
                @edit="onEdit" @delete="onDelete">
    <template v-slot:rowIconsLeft v-if="!isManaged">
      <v-list-item-action>
        <v-btn icon @click="onMove(-1)" :disabled="isFirstItem">
          <v-icon color="grey">fa-sort-up</v-icon>
        </v-btn>
        <v-icon color="grey"> fa-utensils </v-icon>
        <v-icon color="grey" small> fa-grip-lines </v-icon>
        <v-btn icon @click="onMove(1)" :disabled="isLastItem">
          <v-icon color="grey">fa-sort-down</v-icon>
        </v-btn>
      </v-list-item-action>
    </template>
    <template v-slot:aboveContent>
      <v-row align="center" class="chip-top">
        <v-chip x-small class="chip">{{ $t('product') }}</v-chip>
        <v-chip v-if="isVisible" x-small class="chip">{{ $t('visible') }}</v-chip>
        <v-chip v-if="isSpecial" x-small class="chip">{{ $t('special') }}</v-chip>
        <v-chip v-if="hasSpecialFrame" x-small class="chip">{{ $t('specialFrame') }}</v-chip>
        <v-chip v-if="isOutOfStock" x-small class="chip">{{ $t('outOfStock') }}</v-chip>
        <v-chip v-if="isDeleted" x-small class="chip white--text" color="red">{{ $t('deleted') }}</v-chip>
        <v-tooltip v-if="!hasSaleFormat" top>
          <template v-slot:activator="{ on, attrs }">
              <v-icon v-on="on" v-bind="attrs" color="red">mdi-alert-circle</v-icon>
          </template>
          <span>{{ $t('errorProduct') }}</span>
        </v-tooltip>
      </v-row>
    </template>
  </dynameat-row>
</template>

<script>

import DynameatRow from '@dynameat/components/DynameatRow';
import { Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { Components, MapGetters } from '@core/helpers/decorators';
import Component from 'vue-class-component';
import { ProductItem } from '../models';

@Component
@Components({ DynameatRow })
@MapGetters(['masterProductList', 'masterSaleFormatList'])
export default class ProductItemRow extends Vue {
    @Prop({ Number, default: 0 }) index;

    @Prop({ Number, default: 0 }) size;

    @Prop({ Boolean, default: true }) isManaged;

    @Prop({
      Object,
      validator(product) {
        return product instanceof ProductItem;
      },
    }) product;

    get buttonConfigList() {
      return [{
        title: `${this.$t('edit')}`,
        icon: 'mdi-pencil',
        emitName: 'edit'
      },
      {
        title: `${this.$t('delete')}`,
        icon: 'mdi-delete',
        emitName: 'delete'
      }];
    }

    get commercialName() {
      return (this.product.commercial_name) || (this.product.name) || this.$t('noNameError');
    }

    get isVisible() {
      return this.product.is_visible;
    }

    get isOutOfStock() {
      return this.product.out_of_stock;
    }

    get isSpecial() {
      return this.product.special;
    }

    get hasSpecialFrame() {
      return this.product.special_frame;
    }

    get isLastItem() {
      return this.index === this.size - 1;
    }

    get isFirstItem() {
      return this.index === 0;
    }

    get isDeleted() {
      return this.product.is_deleted;
    }

    get masterProduct() {
      return this.masterProductList.find((el) => el.guid === this.product.product);
    }

    get hasSaleFormat() {
      const { masterProduct } = this;
      if (masterProduct) {
        const childFormats = this.masterSaleFormatList.filter((el) => Object.keys(masterProduct.sale_formats).includes(el.guid));
        const masterFormats = this.masterSaleFormatList.filter((el) => el.guid === masterProduct.master_sale_format);
        return [...masterFormats, ...childFormats].length > 0;
      }
      return [];
    }

    onEdit() {
      this.$emit('edit', this.product);
    }

    onDelete() {
      this.$emit('delete', this.product.guid);
    }

    onMove(value) {
      this.$emit('move', this.product, value);
    }

    onClickContent() {
      this.$emit('click-content', this.product);
    }
}
</script>

<style scoped lang="scss">
.chip-top {
  margin-top: 5px;
  margin-left: 0;
}

.chip {
  margin-top: 5px;
  margin-right: 5px;
}

.v-list-item__action--stack {
  align-items: center;
}

.v-list-item__action--stack > .v-icon.v-icon {
  font-size: large;
}

</style>
